
import { Placement } from '@post-office/placements-frontend/confluence-side-nav';
export default Placement;
